import axios from "axios";
import { BASE_API, APPLICATION } from "../../constants";
import { getMenuCategories } from "../menu/GetMenuCategories";

export const fetchMenuData = async ({
  setMenuContext,
  setApplicationNotFound,
}) => {
  try {
    const response = await axios.get(`${BASE_API}api/Menu/MenuItems`, {
      headers: {
        Application: APPLICATION,
      },
    });

    const menuItems = response.data.item1;
    const menuItemExtras = response.data.item2;
    const categories = getMenuCategories(menuItems);

    const newMenuContext = {
      items: menuItems,
      extras: menuItemExtras,
      categories,
    };

    setMenuContext(newMenuContext);
    localStorage.setItem("menuContext", JSON.stringify(newMenuContext));
    setApplicationNotFound(false);
  } catch (error) {
    setApplicationNotFound(true);

    const fallbackMenuContext = {
      items: null,
      extras: null,
      categories: null,
    };

    setMenuContext(fallbackMenuContext);
    localStorage.setItem("menuContext", JSON.stringify(fallbackMenuContext));
  }
};
